import React from "react";
import { PanelAddSmmDomain } from "../../../UI/SmmDomain/Add/PanelAddSmmDomain";

const AddSmmDomain = () => {
  return (
    <div>
      <PanelAddSmmDomain />
    </div>
  );
};

export default AddSmmDomain;
